import {
  createSdk,
  handleResponse,
  getErrorMessages,
  extractErrorMessage,
} from "@fcfcu/sdk";

import uuid from "uuid/v4";
import { detect } from "detect-browser";
import { format } from "date-fns";
import titleCase from "title-case";

const getOrCreateDeviceId = () => {
  const key = "deviceId";

  const deviceId = localStorage.getItem(key);

  if (deviceId) {
    return deviceId;
  }

  const newId = uuid();

  localStorage.setItem(key, newId);

  return newId;
};

const getIpAddress = () => "192.168.1.1";

export const getAppVersion = () => "20.0.11";

const browser = detect();

export const getDefaultNickname = () =>
  `${titleCase(browser.name)} (${format(new Date(), "MM/DD/YYYY")})`;

const setToken = token => localStorage.setItem("token", token);

export default createSdk({
  baseURL: `${process.env.GATSBY_API_URL}/api`,
  getToken: () => localStorage.getItem("token"),
  setToken,
  appVersion: getAppVersion(),
  getDevice: () => ({
    deviceId: getOrCreateDeviceId(),
    ipAddress: getIpAddress(),
    appVersion: getAppVersion(),
    clientType: browser.name,
    clientVersion: browser.version,
  }),
});

export const getTranslatedErrorMessage = ({ error, t }) => {
  if (error.messageKey) {
    return t(error.messageKey, {
      errorMessage: error.message || "",
      defaultValue: error.message,
    });
  }
  return error.message || error.toString();
};

export { handleResponse, getErrorMessages, extractErrorMessage, setToken };



// WEBPACK FOOTER //
// ./src/sdk.js